import { createBrowserHistory } from 'history'

const history = createBrowserHistory() as any

export default history
